import React from 'react';

import ManagedInput from 'components/form/managed_input';

interface Props {
  contactTypes: string[];
  options: {
    contactTypes: {
      label: string;
      value: string;
    }[];
  };
  onChange: (changes: { contactTypes: string[] }) => void;
}

export default function CustomFieldFormContactTypes({ contactTypes, options, onChange }: Props) {
  function toggleContactType(contactType: string) {
    if (contactTypes.includes(contactType)) {
      onChange({ contactTypes: contactTypes.filter(type => type !== contactType) });
    } else {
      onChange({ contactTypes: [...contactTypes, contactType] });
    }
  }

  return (
    <div className="form-group required">
      <label className="control-label">
        Contact types
        <abbr title="required">*</abbr>
      </label>
      <div className="d-flex flex-wrap">
        {options.contactTypes.map(option => (
          <ManagedInput
            checked={contactTypes.includes(option.value)}
            key={option.value}
            label={option.label}
            type="checkbox"
            wrapperClassName="m-0 mr-5 pt-2 one-line"
            onChange={() => toggleContactType(option.value)}
          />
        ))}
      </div>
    </div>
  );
}
